export const COLLABORATION_METHOD_OPTION_KEY = 'CollaborationMethodOption';
export const COLLABORATION_METHOD_SYNC = 'Sync';
export const COLLABORATION_METHOD_ASYNC = 'Async';
export const DESIGN_LIVE_REVIEW_METHOD = 'DesignLive';

export interface ProductOptionWithKey {
    key: { key: string };
}

export interface KeyValueOption {
    key: string;
    value: string;
}

type OptionInput =
    | ReadonlyArray<ProductOptionWithKey | KeyValueOption | null>
    | Record<string, string>
    | null
    | undefined;

/**
 * Checks whether CollaborationMethodOption is present.
 *
 * Accepts either:
 * - A product options array (`[{ key: { key: string } }]`) from a ProductOptionsQuery
 * - A key-value options array (`[{ key: string, value: string }]`) from serviceProductOptions
 * - A selected options record (`Record<string, string>`) built from preselected values
 */
export function hasCollaborationMethodOption(options: OptionInput): boolean {
    if (!options) return false;
    if (!Array.isArray(options)) return COLLABORATION_METHOD_OPTION_KEY in options;

    return options.some(
        (option) => option != null && extractKey(option) === COLLABORATION_METHOD_OPTION_KEY
    );
}

function extractKey(option: ProductOptionWithKey | KeyValueOption): string {
    return 'value' in option ? option.key : option.key.key;
}
